export default __webpack_public_path__ + "static/media/Bloodseer's Cowl.4eb50920.jpg";